import React, { useState } from "react";
import {
  Modal,
  IconButton,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Grid,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    position: "relative",
    width: "80%",
    maxWidth: "600px",
    backgroundColor: "white",
    padding: "20px",
    boxShadow: 24,
    borderRadius: "8px",
    outline: "none",
    overflow: "hidden",
    zIndex: 1300,
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
  },
  table: {
    marginTop: "20px",
  },
  tableCell: {
    textAlign: "center",
  },
  legend: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  checkIcon: {
    color: "green",
  },
  readIcon: {
    color: "orange",
  },
  noAccessIcon: {
    color: "red",
  },
  radioGroup: {
    marginBottom: "20px",
  },
  submitButton: {
    marginTop: "20px",
  },
  hyphenIcon: {
    color: "grey",
  },
});

const RoleChartModal = ({ open, onClose }) => {
  const classes = useStyles();
  const [accessLevel, setAccessLevel] = useState("none");
  const [selectedCells, setSelectedCells] = useState({});

  const handleAccessLevelChange = (event) => {
    setAccessLevel(event.target.value);
  };

  const handleCellClick = (role, cell) => {
    setSelectedCells((prev) => ({
      ...prev,
      [`${role}-${cell}`]: accessLevel,
    }));
  };

  const getIcon = (role, cell) => {
    const cellAccessLevel = selectedCells[`${role}-${cell}`];

    if (cellAccessLevel === "full") {
      return <CheckOutlinedIcon className={classes.checkIcon} />;
    }
    if (cellAccessLevel === "read") {
      return <CheckOutlinedIcon className={classes.readIcon} />;
    }
    if (cellAccessLevel === "none") {
      return <CloseOutlinedIcon className={classes.noAccessIcon} />;
    }
    return <RemoveOutlinedIcon className={classes.hyphenIcon} />;
  };

  const handleSubmit = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={(event) => event.stopPropagation()}
      aria-labelledby="role-chart-modal-title"
      aria-describedby="role-chart-modal-description"
      className={classes.modal}
    >
      <Box
        className={classes.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          id="role-chart-modal-title"
          variant="h6"
          component="h2"
          gutterBottom
        >
          Custom Role
        </Typography>
        <Grid item xs={12} sm={12} md={12} mb={2}>
          <TextField label="Role Name" variant="outlined" fullWidth />
        </Grid>
        <RadioGroup
          value={accessLevel}
          onChange={handleAccessLevelChange}
          className={classes.radioGroup}
          row
        >
          <FormControlLabel
            value="full"
            control={<Radio />}
            label="Full Access"
          />
          <FormControlLabel
            value="read"
            control={<Radio />}
            label="Read Access"
          />
          <FormControlLabel
            value="none"
            control={<Radio />}
            label="No Access"
          />
        </RadioGroup>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}>Roles</TableCell>
              <TableCell className={classes.tableCell}>Role Access</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              "Dashboard",
              "Products",
              "Subscriptions",
              "Billing",
              "Settings",
              "User",
            ].map((role) => (
              <TableRow key={role}>
                <TableCell className={classes.tableCell}>{role}</TableCell>
                <TableCell
                  className={classes.tableCell}
                  onClick={() => handleCellClick(role, "admin")}
                >
                  {getIcon(role, "admin")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "8px",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default RoleChartModal;
